(function () {
	'use strict';

	angular
		.module('app.service')
		.factory('homeService', homeService);

	function homeService(commonService, $http, apiUrl) {
		var service = {
			getMhr: getMhr,
			getTsu: getTsu,
			getNext: getNext,
			getNextMore: getNextMore
		};

		var homeUrl = apiUrl.tsApi + 'home/';

		function getMhr() {
			var param = {
				menuSerilNo: getMenuQueryString()
			};
			commonService.setParams(param);
			return $http.post(homeUrl + 'getMhr', param);
		}

		function getTsu() {
			var param = {
				menuSerilNo: getMenuQueryString(),
				siteCode: 4
			};
			commonService.setParams(param);
			return $http.post(homeUrl + 'getTsu', param);
		}

		function getNext() {
			var param = {
				menuSerilNo: getMenuQueryString(),
				siteCode: 2
				
			};
			commonService.setParams(param);

			return $http.post(homeUrl + 'getNext', param);
		}

		function getNextMore(currentPage) {
			var param = {
				currentPage: currentPage,
				menuSerilNo: getMenuQueryString(),
				siteCode: 2
			};
			commonService.setParams(param);
			return $http.post(homeUrl + 'getNextMore', param);
		}

		return service;
	}
})();